<template>
  <div class="etab-name-component">
    <Field
      v-slot="{ errors, field, value }"
      v-model="_name"
      :name="$filters.formLabelValidation($t('ETAB.FORMS.LABELS.@ETAB_NAME'))"
      :rules="{ required: true }"
    >
      <QInput
        v-bind="field"
        :model-value="value"
        :label="$t('ETAB.FORMS.LABELS.@ETAB_NAME')"
        :name="iModel.etabName"
        :data-vv-name="iModel.etabName"
        type="text"
        :error="errors.length > 0"
        :error-message="errors[0]"
      />
    </Field>
  </div>
</template>

<script>
  import { Field } from "vee-validate";

  export default {
    components: {
      Field,
    },
    props: {
      name: { type: String, default: "" },
      iModel: { type: Object, default: () => ({}) },
    },
    emits: ["update:name"],
    computed: {
      _name: {
        get() {
          return this.name;
        },
        set(value) {
          this.$emit("update:name", value);
        },
      },
    },
  };
</script>
